import { Button } from '@resurs/midas-react'
import { midas } from '@resurs/midas'
import React from 'react'
import styles from './ArrowBackButton.module.scss'
import { classNames } from '../../../util/helpers'
import {useHistory} from "react-router";

const ArrowBackButton = ({ buttonText }) => {
  const history = useHistory()

  return (
  <div className={styles.buttonContainer}>
    <Button
      size="large"
      type="link"
      onClick={() => history.goBack()}
    >
      <i className={classNames(midas.icon, midas.midasArrow31)} />
      <span>{buttonText}</span>
    </Button>
  </div>
)}

export default ArrowBackButton
